import * as yup from 'yup'

export class VehicleCheckInTPMSPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInTPMSPhotoFile?: File = undefined
  vehicleCheckInHasTPMSIndicator?: boolean = undefined
}

export const vehicleCheckInTPMSPhotoValidationSchema = yup.object({
  vehicleCheckInTPMSPhotoFile: yup.mixed().nullable(),
  vehicleCheckInHasTPMSIndicator: yup.boolean().nullable()
})
